

export default {
  name: "shadowStyle",
  nickname: "阴影样式",
  desc:
    '<a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.axisPointer.type">axisPointer.type</a> 为 <code class="codespan">&#39;shadow&#39;</code> 时有效。',
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc: "填充的颜色。",
      value: "'rgba(150,150,150,0.3)",
      defaultValue: "'rgba(150,150,150,0.3)",
      type: "pureValue",
      eType: "color",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    opacity: {
      name: "opacity",
      nickname: "透明度",
      desc: "图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。",
    },
  },
}
